import { db } from '../firebaseInit'
import _ from 'lodash'

export default {
  state: {
    allDoubleBookedVendors: null,
    doubleBookedVendor: [],
    vendorList: [],
    vendorProjects: []
  },
  mutations: {
    getAllDoubleBookedVendors (state, payload) { // Adding payload.removeId (which is the taskId) will remove that task as double booked from the list
      if (payload && !payload.removeId && payload.removeId !== 0) {
        if (state.allDoubleBookedVendors && state.allDoubleBookedVendors[payload.sourceId]) {
          state.allDoubleBookedVendors[payload.sourceId].push(payload)
        } else {
          state.allDoubleBookedVendors = { ...state.allDoubleBookedVendors, [payload.sourceId]: [] }
          state.allDoubleBookedVendors[payload.sourceId].push(payload)
        }
      }
      if (payload && (payload.removeId || payload.removeId === 0)) {
        // delete state.allDoubleBookedVendors[payload.removeId]
        state.allDoubleBookedVendors[payload.removeId] = null
      }
      if (!payload) {
        state.allDoubleBookedVendors = null
      }
    },
    checkVendorDoubleBooked (state, payload) {
      if (payload) {
        state.doubleBookedVendor.push(payload)
      } else {
        state.doubleBookedVendor = []
      }
    },
    removeVendorFromTask (state, payload) {
      this.state.tasks.projectTasks[payload.index].vendor_name = null
      this.state.tasks.projectTasks[payload.index].vendor_id = null
      if (this.state.tasks.getProjectTask && this.state.tasks.getProjectTask.id === this.state.tasks.projectTasks[payload.index].id) {
        this.state.tasks.getProjectTask.vendor_name = null
        this.state.tasks.getProjectTask.vendor_id = null
      }
    },
    addVendorToTask (state, payload) {
      const index = this.state.tasks.projectTasks.findIndex(i => i.id === payload.task.id)
      this.state.tasks.projectTasks[index].vendor_name = payload.vendor.name
      this.state.tasks.projectTasks[index].vendor_id = payload.vendor.id
    },
    vendorProjects (state, payload) {
      state.vendorProjects = payload
    },
    getVendorList (state, payload) {
      state.vendorList = payload
    },
    createVendor (state, payload) {
      state.vendorList.push(payload)
    },
    editVendor (state, payload) {
      state.vendorList[payload.vendorListIndex] = { ...state.vendorList[payload.vendorListIndex], ...payload.newState }
    },
    deleteVendor (state, payload) {
      state.vendorList.splice(payload.itemIndex, 1)
    }
  },
  actions: {
    getAllDoubleBookedVendors ({ commit, dispatch }, payload) { // Pass an OPTIONAL array of task details to check: [{ taskId, vendorId, dueDate }, { taskId, vendorId, dueDate }]
      commit('getAllDoubleBookedVendors', null) // Clears Existing Data
      if (payload) {
        payload.forEach(task => {
          if (task.dueDate.seconds) {
            task.dueDate = new Date(task.dueDate.seconds * 1000)
          }
          dispatch('checkVendorDoubleBooked', task)
        })
      } else {
        let possibleDoubleBooked = []
        db.collection('tasks').where('active', '==', true).where('is_double_booked', '==', true).get().then(tasks => {
          tasks.forEach(task => {
            if (task.data().vendor_id) {
              possibleDoubleBooked.push({ taskId: task.id, vendorId: task.data().vendor_id, dueDate: new Date(task.data().due_date.seconds * 1000) })
            } else { // Remove Double Bookings from tasks WITHOUT a vendor_id
              dispatch('editTask', [{ id: task.id, is_double_booked: false }])
            }
          })
        }).then(() => {
          possibleDoubleBooked.forEach(task => {
            dispatch('checkVendorDoubleBooked', task)
          })
        })
      }
    },
    checkVendorDoubleBooked ({ commit, dispatch }, payload) { // Checks if vendor is double booked for same time period { taskId, isDoubleBooked, vendorId, dueDate, isTemplateTask(Optional), ifProjectTasks }
      commit('checkVendorDoubleBooked', null) // Null Clears The Array
      const startDate = new Date(payload.dueDate.toDateString())
      const endDate = new Date(payload.dueDate.toDateString())
      endDate.setDate(endDate.getDate() + 1)
      db.collection('tasks').where('active', '==', true).where('vendor_id', '==', payload.vendorId).where('due_date', '>=', startDate).where('due_date', '<=', endDate)
      .get().then((response, index) => {
        let tasks = []
        response.forEach(taskRes => {
          tasks.push(taskRes.data())
        })
        tasks = tasks.filter(f => f.id !== payload.taskId)
        if (tasks.length < 1 && payload.isDoubleBooked) { // Remove double booking if it no longer applies
          dispatch('editTask', [{ id: payload.taskId, is_double_booked: false }])
        }
        if (tasks.length > 0) {
          if (!payload.is_double_booked && !payload.isTemplateTask && payload.ifProjectTasks) { // If is_double_booked is false, set it to true IF FROM Project Tasks
            dispatch('editTask', [{ id: payload.taskId, is_double_booked: true }])
          }
          tasks.forEach(taskRes => {
            const task = { ...taskRes, id: taskRes.id }
            if (task.id !== payload.taskId) { // Do not include the SELF task
              db.collection('projects').doc(task.projectId).get().then(projectResponse => {
                const project = { ...projectResponse.data(), id: task.projectId }
                if (!task.is_double_booked) {
                  dispatch('editTask', [{ id: task.id, is_double_booked: true }])
                }
                commit('checkVendorDoubleBooked', { projectId: task.projectId, projectName: project.name, taskId: task.id, taskName: task.name, startDate: task.start_date, dueDate: task.due_date, vendorId: task.vendor_id })
                commit('getAllDoubleBookedVendors', { sourceId: payload.taskId, projectId: task.projectId, projectName: project.name, taskId: task.id, taskName: task.name, startDate: task.start_date, dueDate: task.due_date, vendorId: task.vendor_id })
              })
            }
          })
        }
      })
    },
    vendorProjects ({ commit }, payload) {
      let projects = []
      db.collection('tasks').where('deleted', '==', false).where('vendor_id', '==', payload).get().then(query => {
        query.forEach(task => {
          db.collection('projects').where('tasks.' + task.id, '==', true).get().then(response => {
            response.forEach(project => {
              if (project.data().deleted !== true) {
                projects.push({ project: { ...project.data(), id: project.id }, task: task.data() })
              }
            })
          })
        })
      })
      commit('vendorProjects', projects)
    },
    checkToRemoveDoubleBooked ({ commit, dispatch, getters }, payload) { // Pass { taskId: task.task.id, isDoubleBooked: task.task.is_double_booked, vendorId: task.task.vendor_id, dueDate: task.newDueDate } task object: specifically id, is_double_booked, due_date
      if (payload.isDoubleBooked && payload.vendorId) { // Remove Other Double Bookings if appropriate
        let dueDate = payload.dueDate
        if (payload.dueDate.seconds) {
          dueDate = new Date(payload.dueDate.seconds * 1000)
        }
        const startDate = new Date(dueDate.toDateString())
        const endDate = new Date(dueDate.toDateString())
        endDate.setDate(endDate.getDate() + 1)
        let doubleBookedTasks = []
        db.collection('tasks').where('active', '==', true).where('vendor_id', '==', payload.vendorId).where('due_date', '>=', startDate).where('due_date', '<=', endDate)
        .get().then((response, index) => {
          response.forEach(task => {
            if (task.id !== payload.taskId) {
              doubleBookedTasks.push(task.data())
            }
          })
        }).then(() => {
          if (doubleBookedTasks.length === 1) {
            dispatch('editTask', [{ id: doubleBookedTasks[0].id, is_double_booked: null }])
          }
        })
      }
    },
    removeVendorFromTask ({ commit, dispatch, getters }, payload) {
      dispatch('editTask', [{ id: payload.task.id, vendor_id: null, is_double_booked: null }])
      dispatch('checkToRemoveDoubleBooked', { taskId: payload.task.id, isDoubleBooked: payload.task.is_double_booked, vendorId: payload.task.vendor_id, dueDate: payload.task.due_date })
      const logData = { timestamp: new Date(), collection: 'task', type: 'remove vendor', user_id: getters.user.id, record_id: payload.task.id, message: getters.user.first_name + ' removed the vendor (' + payload.vendor + ') from the project ' + payload.project.name + ' from the task: ' + payload.task.name, icon: 'assignment_ind' }
      dispatch('commitLog', logData)
      const index = getters.projectTasks.findIndex(i => i.id === payload.task.id)
      const newPayload = { index: index }
      commit('removeVendorFromTask', newPayload)
    },
    addVendorToTask ({ commit, dispatch, getters }, payload) {
      dispatch('editTask', [{ id: payload.task.id, vendor_id: payload.vendor.id }])
      const newPayload = {projectId: payload.project.id, task: payload.task, vendor: payload.vendor}
      commit('addVendorToTask', newPayload)
      const logData = { timestamp: new Date(), collection: 'task', type: 'create vendor', user_id: getters.user.id, record_id: payload.task.id, message: getters.user.first_name + ' added a new vendor (' + payload.vendor.name + ') to the project ' + payload.project.name + ' to the task: ' + payload.task.name, icon: 'assignment_ind' }
      dispatch('commitLog', logData)
    },
    // Get Vendor List
    getVendorList ({ commit, getters }, payload) {
      let newVendorList = []
      commit('setLoading', true)
      db.collection('vendors').where('deleted', '==', false).get()
      .then(query => {
        query.forEach(item => {
          newVendorList.push({ ...item.data(), id: item.id })
        })
      }).then(() => {
        commit('getVendorList', newVendorList)
        commit('setLoading', false)
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setError', { timestamp: new Date(), collection: 'vendors', type: 'get', user_id: getters.user.id, route: '/vendors', error: error.message })
        commit('setLoading', false)
      })
    },
    createVendor ({ commit, getters, dispatch }, payload) {
      const { id, ...withoutFirst } = payload
      const newVendor = { ...withoutFirst, created_by: getters.user.id, active: true, deleted: false }
      db.collection('vendors').doc(payload.id).set(newVendor).then(doc => {
        const logData = { timestamp: new Date(), collection: 'vendors', type: 'created', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' created a new vendor: ' + payload.company_name + '.', icon: 'assignment_ind' }
        dispatch('commitLog', logData)
        commit('createVendor', payload)
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setError', { timestamp: new Date(), collection: 'vendors', type: 'create', user_id: getters.user.id, route: '/vendors', error: error.message })
      })
    },
    deleteVendor ({ commit, state, getters, dispatch }, payload) {
      db.collection('vendors').doc(payload.id).update({
        active: false,
        deleted: true
      })
      const vendorListIndex = state.vendorList.findIndex(x => x.id === payload.id)
      const newPayload = { itemIndex: vendorListIndex }
      const logData = { timestamp: new Date(), collection: 'vendors', type: 'deleted', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted the vendor: ' + payload.company_name + '.', icon: 'assignment_ind' }
      dispatch('commitLog', logData)
      commit('deleteVendor', newPayload)
    },
    addVendorContact ({ commit, getters, dispatch }, payload) {
      db.collection('vendors').doc(payload.id).update({
        vendor_contacts: payload.arrayPayload
      })
      .then(() => {
        const logData = { timestamp: new Date(), collection: 'vendors', type: 'created', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' created a new vendor contact: ' + payload.newContact.first_name + ' ' + payload.newContact.last_name + '.', icon: 'assignment_ind' }
        dispatch('commitLog', logData)
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setError', { timestamp: new Date(), collection: 'vendors', type: 'create', user_id: getters.user.id, route: '/vendors', error: error.message })
      })
    },
    deleteVendorContact ({ commit, getters, dispatch }, payload) {
      db.collection('vendors').doc(payload.id).update({
        vendor_contacts: payload.contactArray
      })
      .then(() => {
        const logData = { timestamp: new Date(), collection: 'vendors', type: 'deleted', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted a vendor contact: ' + payload.deletedContact.first_name + ' ' + payload.deletedContact.last_name + '.', icon: 'assignment_ind' }
        dispatch('commitLog', logData)
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setError', { timestamp: new Date(), collection: 'vendors', type: 'delete', user_id: getters.user.id, route: '/vendors', error: error.message })
      })
    },
    editVendor ({ commit, state, getters, dispatch }, payload) {
      db.collection('vendors').doc(payload.id).update(payload.newState)
      const logData = { timestamp: new Date(), collection: 'vendors', type: 'edit', user_id: getters.user.id, record_id: payload.id, changed_from: payload.previousState, changed_to: payload.newState, message: getters.user.first_name + ' made changes to the vendor: ' + payload.company_name + '.', icon: 'assignment_ind' }
      const vendorListIndex = state.vendorList.findIndex(x => x.id === payload.id)
      const newPayload = { ...payload, vendorListIndex: vendorListIndex }
      dispatch('commitLog', logData)
      commit('editVendor', newPayload)
    },
    editVendorContact ({ commit, getters, dispatch }, payload) {
      db.collection('vendors').doc(payload.id).update({
        vendor_contacts: payload.array
      })
      .then(() => {
        const logData = { timestamp: new Date(), collection: 'vendors', type: 'edited', user_id: getters.user.id, record_id: payload.id, changed_from: payload.from, changed_to: payload.to, message: getters.user.first_name + ' changed the vendor contact: ' + payload.to.first_name + ' ' + payload.to.last_name + '.', icon: 'assignment_ind' }
        dispatch('commitLog', logData)
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setError', { timestamp: new Date(), collection: 'vendors', type: 'edited', user_id: getters.user.id, route: '/vendors', error: error.message })
      })
    }
  },
  getters: {
    getAllDoubleBookedVendors (state) {
      // Dedup - Returns Objects of Arrays by keyname = source task id
      if (state.allDoubleBookedVendors) {
        let finalOutput = null
        const objKeys = Object.keys(state.allDoubleBookedVendors)
        objKeys.forEach(key => {
          if (state.allDoubleBookedVendors[key]) {
            const uniqueArray = _.uniqWith(state.allDoubleBookedVendors[key], _.isEqual)
            finalOutput = { ...finalOutput, [key]: uniqueArray }
          }
        })
        return finalOutput
      } else {
        return null
      }
    },
    getDoubleBookedVendor (state) {
      if (state.doubleBookedVendor.length > 0) {
        return state.doubleBookedVendor
      } else {
        return null
      }
    },
    vendorProjects (state) {
      return state.vendorProjects
    },
    vendorList (state) {
      return state.vendorList
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/vendors.js